import styled from 'styled-components';
import { Chip } from '@mui/material';

export const Container = styled.div`
  margin-bottom: 24px;
`;

export const FiltersContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
`;

export const FilterChip = styled(Chip)`
  && {
    background-color: #f5f5f5;
    border: 1px solid #e0e0e0;
    color: #333;
    font-size: 0.875rem;
    height: 36px;

    .MuiChip-label {
      padding: 0 12px;
      font-weight: 400;

      strong {
        font-weight: 600;
        color: #89BD23;
      }
    }

    .MuiChip-deleteIcon {
      color: #666;
      width: 18px;
      height: 18px;
      margin-right: 4px;
      transition: color 0.2s ease;

      &:hover {
        color: #333;
      }
    }

    &:hover {
      background-color: #eeeeee;
      border-color: #bdbdbd;
    }
  }
`;
